import React, { useState, useEffect } from 'react';
import { API_BASE_URL } from '../config';
import "./FiiDiiData.css";
import RefreshButton from './RefreshButton';

const FiiDiiData = ({ onBack }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("daily");

  const currentYearMonth = new Date().toISOString().slice(0, 7); // "YYYY-MM"

  const fetchData = async (type) => {
    setLoading(true);
    try {
      const response = await fetch(
        `${API_BASE_URL}/fii-dii-data?request_type=${type}&year_month=${currentYearMonth}`
      );
      const result = await response.json();

      console.log("🚀 Full API Response:", result);

      // ✅ Use only "records" since that's the structure
      let fiiDiiArray = result.records || [];
      setData(fiiDiiArray);

      console.log("✅ Final Data for table:", fiiDiiArray);
    } catch (error) {
      console.error("❌ Error fetching data:", error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(activeTab);
  }, [activeTab, fetchData]);

  return (
    <div className="fii-dii-container">
            <header className="heatmap-header">
        <div className="heatmap-header-container">
          <div className="logo">
            <img src="images/Final Font Stocks4U1.png" className="logo-text" alt="Stocks4U"/>
          </div>
          <div className="heatmap-user">
            <RefreshButton 
              onRefresh={() => fetchData(activeTab)} 
              isLoading={loading}
              size="small"
              style={{ marginRight: '10px' }}
            />
            <button className="heatmap-back-btn" onClick={onBack}>← Back to Dashboard</button>
          </div>
        </div>
      </header>
   

      <h2>FII / DII Data</h2>

      {/* Tabs */}
      <div className="tabs">
        {["daily", "weekly", "monthly"].map((tab) => (
          <button
            key={tab}
            className={`tab-button ${activeTab === tab ? "active" : ""}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab.charAt(0).toUpperCase() + tab.slice(1)}
          </button>
        ))}
      </div>

      {/* Table */}
      {loading ? (
        <p>Loading...</p>
      ) : (
        <table className="fii-dii-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>FII Net (₹ Cr)</th>
              <th>DII Net (₹ Cr)</th>
              <th>Net Position (₹ Cr)</th>
            </tr>
          </thead>
<tbody>
  {Array.isArray(data) && data.length > 0 ? (
    data.map((row, idx) => {
      const fii = Number(row.fii_net_value) || 0;
      const dii = Number(row.dii_net_value) || 0;
      const net = fii + dii;

      return (
        <tr key={idx}>
          {/* Date */}
          <td>
            {row.created_at
              ? new Date(row.created_at).toLocaleDateString("en-GB")
              : "N/A"}
          </td>

          {/* FII Net */}
          <td className={fii >= 0 ? "positive" : "negative"}>
            {fii.toFixed(2)}
          </td>

          {/* DII Net */}
          <td className={dii >= 0 ? "positive" : "negative"}>
            {dii.toFixed(2)}
          </td>

          {/* Net Position */}
          <td className={net >= 0 ? "positive" : "negative"}>
            {net.toFixed(2)}
          </td>
        </tr>
      );
    })
  ) : (
    <tr>
      <td colSpan="4" style={{ textAlign: "center" }}>
        No data available
      </td>
    </tr>
  )}
</tbody>
        </table>
      )}
    </div>
  );
};

export default FiiDiiData;
